import React from "react";

function PillarsPage({ pillars, reportNumber, shishen, _pctMap, isOver, isUnder, ELEM_LABEL,
  kwHasData, kwRotation, kwBranches, kw, _backend, yongElem, lang }) {

  const STEM_ELEM = {甲:"wood",乙:"wood",丙:"fire",丁:"fire",戊:"earth",己:"earth",庚:"metal",辛:"metal",壬:"water",癸:"water"};
  const pElem = (gz) => STEM_ELEM[gz?.[0]] || "earth";
  const dayStem = pillars?.day?.gz?.[0] || "";
  const dayElemZh = ({wood:"木",fire:"火",earth:"土",metal:"金",water:"水"})[STEM_ELEM[dayStem]] || "";

  return (
    <div className="lr2-page" id="ch1">
      <div className="lr2-ph">
        <span className="lr2-ph-num">01</span>
        <div>
          <div className="lr2-ph-title">四柱命盘 · 能量地图</div>
          <div className="lr2-ph-sub">FOUR PILLARS CHART · FIVE ELEMENTS MAP</div>
        </div>
      </div>
      <div className="lr2-section">
        <div className="lr2-st">四柱八字总览</div>
        <div className="lr2-pgrid">
          {["year","month","day","hour"].map(p=>{
            const ec = pElem(pillars[p]?.gz);
            return (
              <div key={p} className="lr2-pcol">
                <div className="lr2-phead">{({year:"年 柱",month:"月 柱",day:"日 柱 ✦",hour:"时 柱"})[p]}</div>
                <div className={"lr2-pgz "+ec}>{pillars[p]?.gz||"—"}</div>
                <div className="lr2-pshen">{shishen?.[["year","month","day","hour"].indexOf(p)]?.stemShishen||p==="day"?"日主":""}<small>{pillars[p]?.se||""} · {pillars[p]?.be||""}</small></div>
              </div>
            );
          })}
        </div>
        {kwHasData && (() => {
          const kwp = _backend?.kongwang_plain || {};
          const ktitle = kwp.title || (lang==="zh"?"文书审批 · 好事多磨":"Documents · Pending Resolution");
          const kbody = kwp.body || (lang==="zh"?"涉及签字盖章的事务进度可能比预期慢，多核对细节，稳扎稳打即可。":"Documents and approvals may take longer than expected. Double-check details and proceed steadily.");
          return (
          <div className="lr2-kw">
            <strong>⚡</strong>
            <div>
              <strong>{ktitle}</strong>
              <div style={{fontSize:12,color:"#555",marginTop:4,lineHeight:1.7}}>{kbody}</div>
            </div>
          </div>
          );
        })()}
      </div>
      <div className="lr2-section">
        <div className="lr2-st">五行能量分布</div>
        <div className="lr2-ebars">
          {["wood","fire","earth","metal","water"].map(e=>{
            const pct = _pctMap[e]||0;
            const note = isOver(pct) ? <strong style={{color:({wood:"#2D6A4F",fire:"#B91C1C",earth:"#A07820",metal:"#6B7280",water:"#1E3A8A"})[e]}}> · 严重偏旺</strong>
                       : isUnder(pct) ? <strong style={{color:({wood:"#2D6A4F",fire:"#B91C1C",earth:"#A07820",metal:"#6B7280",water:"#1E3A8A"})[e]}}> · 严重偏缺</strong>
                       : null;
            return (
              <div key={e} className="lr2-erow">
                <span className={"lr2-elabel "+e}>{ELEM_LABEL[e]}</span>
                <div className="lr2-ewrap">
                  <div className="lr2-etrack"><div className={"lr2-efill "+e} style={{width:pct+"%"}}/></div>
                  <div className="lr2-ecount">{ELEM_LABEL[e]}元素{note}</div>
                </div>
                <span className="lr2-epct">{pct.toFixed(0)}%</span>
              </div>
            );
          })}
        </div>
        <div className="lr2-dawn" style={{marginTop:16}}>
          <strong>关键洞察：</strong>{
            _backend?.element_insight ||
            (lang==="zh"
              ? `${dayElemZh}日主格局——五行平衡是理解你命盘所有现象的核心钥匙。补${yongElem||"用神"}（用神）是平衡这个命盘最直接的路径。`
              : `${dayStem||"—"} day master pattern: balancing five elements is the key. Reinforce ${yongElem||"the favorable element"} as the most direct path.`)
          }
        </div>
      </div>
      <div className="lr2-quote">
        「五行不是宿命的枷锁，而是你出发时携带的地形图。知道哪里是高山、哪里是河流，行路才能借势而行。」
        <cite>— 澄光能量 · 能量框架 v2.0</cite>
      </div>
      <div className="lr2-pf"><span className="lr2-pf-label">澄光能量 · {reportNumber}</span><span className="lr2-pf-seal lr2-pf-current">1</span></div>
    </div>
  );
}

export default PillarsPage;
